class BESSAppProjectEditorTextAreaField extends BESSAppProjectEditorInputField {

    _templateForInput() {
        return '<textarea rows="20" class="form-control field-editor app-validation-parent"></textarea>';
    }

    _configureView(node) {
        let input = node.find('textarea');
        this.input = input;
        this._configureInput(input);
    }

    _configureInput(input) {
        input.attr('name', this.field.label)
            .val(this.displayValue);

        if (this.field.placeholder) {
            input.attr('placeholder', this.field.placeholder);
        }

        if (this.field.isRequired) {
            input.attr('required', 'required');
        }
    }
}
